import { BemessungenMikropfaehle } from "../../store/slices/bemessungenMikropfaehleSlice";
import { BemessungssituationState } from "../../store/slices/innereSlice";

const setInterpolation = (belastungsartUndRichtung, availableCompressions) => {
  let { [belastungsartUndRichtung]: interpolation } = availableCompressions;

  return interpolation;
};

function calcRmax(interpolationSplit, Cist) {
  const BasenumberCist = Math.floor(Cist);
  let Rmax;
  let firstVal = [];
  let secondVal = [];
  let x1 = 0;
  let x2 = 0;
  let y1 = 0;
  let y2 = 0;

  interpolationSplit.map((el) => {
    let newVal = el.split(":");
    firstVal.push(Number(newVal[0]));
    secondVal.push(Number(newVal[1]));
  });

  if (BasenumberCist < Number(firstVal[0])) {
    Rmax = Number(secondVal[0]);
  } else if (BasenumberCist >= Number(firstVal[firstVal.length - 1])) {
    Rmax = Number(secondVal[secondVal.length - 1]);
  } else {
    for (let index = 0; index < firstVal.length + 1; index++) {
      if (index + 1 <= firstVal.length) {
        if (BasenumberCist >= firstVal[index] && BasenumberCist < firstVal[index + 1]) {
          x1 = Number(firstVal[index]);
          x2 = Number(firstVal[index + 1]);
          y1 = Number(secondVal[index]);
          y2 = Number(secondVal[index + 1]);
          break;
        }
      }
    }
    Rmax = y1 + ((y2 - y1) / (x2 - x1)) * (BasenumberCist - x1);
  }

  return Rmax;
}

function calcCsol(interpolationSplit, designLoad) {
  let Csol;
  let firstVal = [];
  let secondVal = [];
  let x1 = 0;
  let x2 = 0;
  let y1 = 0;
  let y2 = 0;
  let Xcalculated = Number(designLoad) * 1.15;

  interpolationSplit.map((el) => {
    let newVal = el.split(":");
    secondVal.push(newVal[0]);
    firstVal.push(newVal[1]);
  });

  if (Xcalculated < Number(firstVal[0])) {
    Csol = Number(secondVal[0]);
  } else if (Xcalculated > Number(firstVal[firstVal.length - 1])) {
    Csol = Number(secondVal[secondVal.length - 1]);
  } else {
    for (let index = 0; index < firstVal.length + 1; index++) {
      if (index + 1 <= firstVal.length) {
        if (Xcalculated > firstVal[index] && Xcalculated < firstVal[index + 1]) {
          x1 = Number(firstVal[index]);
          x2 = Number(firstVal[index + 1]);
          y1 = Number(secondVal[index]);
          y2 = Number(secondVal[index + 1]);
          break;
        }
      }
    }
    Csol = y1 + ((y2 - y1) / (x2 - x1)) * (Xcalculated - x1);
  }

  return Csol;
}

const BerechneInnereTragfaehigkeit = (props) => {
  const {
    bemessungenMikropfaehle,
    bemessungssituation,
    tragglied,
    bemessungslast,
    bohrkronendurchmesser,
    belastungsartUndRichtung,
    traggliedDaten,
    teilsicherheitsbeiwert,
  } = props;

  if (!belastungsartUndRichtung || !traggliedDaten) {
    //return;
    return {
      Csol: null,
      fixedN: null,
      Rcd: null,
      Rmax: null,
      EC: null,
      Cist: null,
      Rd: null,
      D_a: null,
      Amin: null,
      Rk: null,
    };
  }
  // interpolation
  let interpolation = setInterpolation(belastungsartUndRichtung, {
    druckpfahl: traggliedDaten?.interpolation.druckpfahl,
    zugpfahl: traggliedDaten?.interpolation.zugpfahl,
  });

  let interpolationSplit = interpolation.split(";");
  let Csol = calcCsol(interpolationSplit, bemessungslast);

  // let Csol =
  //   bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7
  //     ? 20
  //     : bemessungssituation == BemessungssituationState.TEMPORÄR
  //     ? 20
  //     : calcCsol(interpolationSplit, bemessungslast);

  if (bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7) {
    Csol = 20;
  } else {
    if (bemessungssituation == BemessungssituationState.TEMPORÄR) {
      Csol = 20;
    }
  }

  if (!tragglied || !bemessungslast || !bohrkronendurchmesser) {
    return {
      Csol: isNaN(Csol) ? null : Csol,
      fixedN: null,
      Rcd: null,
      Rmax: null,
      EC: null,
      Cist: null,
      Rd: null,
      D_a: null,
      Amin: null,
      Rk: null,
    };
  }

  const Cist =
    (Number(bohrkronendurchmesser) + Number(20) - Number(traggliedDaten?.durchmesser)) / 2;

  const Rd = Number(traggliedDaten?.max_charakteristische_tragfaehigkeit) / Number(2);

  let Rmax = null;
  if (
    bemessungssituation == BemessungssituationState.TEMPORÄR ||
    bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7
  ) {
    Rmax = Number(traggliedDaten?.max_charakteristische_tragfaehigkeit);
  } else {
    Rmax = Number(calcRmax(interpolationSplit, Cist));
  }

  let Rcd = Number(Rmax) / Number(teilsicherheitsbeiwert);

  let durchmesserDesRohres = Number(traggliedDaten?.durchmesser) + Number(2 * Csol ?? 0);

  let minimalerRandabstand =
    Number(1.5 * durchmesserDesRohres) +
    Number(0.5 * traggliedDaten?.kopfkonstruktion.kantenlaenge);

  return {
    Csol: Csol,
    fixedN: bemessungslast / Rcd,
    Rcd: Rcd,
    Rmax: Rmax,
    EC: traggliedDaten?.rmkec,
    Cist: Cist,
    Rd,
    D_a: traggliedDaten?.durchmesser,
    Amin: traggliedDaten?.kopfkonstruktion.abstand_uebergangsrohr,
    Rk: traggliedDaten?.max_charakteristische_tragfaehigkeit,
    durchmesserDesRohres: durchmesserDesRohres,
    minimalerRandabstand: minimalerRandabstand,
  };
};

export default BerechneInnereTragfaehigkeit;
